import styled from 'styled-components'

export const Slider = styled.div<any>`
  position: relative;
  display: grid;
  grid-auto-flow: column;
  /* track is the container width; each slide column is one full container width */
  width: 100%;
  grid-auto-columns: 100%;
  user-select: none;
  touch-action: pan-y;
  -webkit-user-drag: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  z-index: ${(props: any) => (props.$isZooming ? 20 : 0)};
`

export const Container = styled.div`
  overflow: hidden;
`

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 20;
`

export const SlideOverlay = styled.div<any>`
  position: relative;
  z-index: ${(props: any) => (props.$inFront ? 10 : 0)};
`
